import React from 'react';
import { IOldIconProps } from './type';

const Question: React.FC<IOldIconProps> = ({
  color = '#000',
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0H15C22.732 0 29 6.26801 29 14C29 21.732 22.732 28 15 28H14C6.26801 28 0 21.732 0 14Z"
        fill={color}
      />
      <path
        d="M13.3376 16.512V16.24C13.3376 15.8667 13.375 15.5467 13.4496 15.28C13.535 15.0027 13.6896 14.72 13.9136 14.432C14.1376 14.1333 14.4576 13.7813 14.8736 13.376C15.1616 13.088 15.3856 12.8267 15.5456 12.592C15.7163 12.3467 15.8016 12.0533 15.8016 11.712C15.8016 11.2747 15.6843 10.944 15.4496 10.72C15.2256 10.4853 14.895 10.368 14.4576 10.368C13.9563 10.368 13.5723 10.4907 13.3056 10.736C13.0496 10.9813 12.863 11.3707 12.7456 11.904L10.5536 11.664C10.6816 10.704 11.071 9.92 11.7216 9.312C12.3723 8.69333 13.3216 8.384 14.5696 8.384C15.743 8.384 16.6443 8.656 17.2736 9.2C17.903 9.744 18.2176 10.464 18.2176 11.36C18.2176 11.9467 18.0896 12.4587 17.8336 12.896C17.5883 13.3333 17.2416 13.7547 16.7936 14.16C16.4416 14.48 16.1696 14.7573 15.9776 14.992C15.7963 15.216 15.6683 15.4347 15.5936 15.648C15.5296 15.8507 15.4976 16.08 15.4976 16.336V16.512H13.3376ZM15.5616 17.616V20H13.2576V17.616H15.5616Z"
        fill="white"
      />
    </svg>
  );
};

export default Question;
